import errors from './errors/index.js';
import translation from './translation/index.js';
const plPL = Object.freeze({
    translation,
    errors,
});
export default plPL;
